<template>
  <div id="partner-box">
    <h3 class="center">Partner</h3>
    <br>
    <p>Wir arbeiten mit Partnern aus der Region Freiburg, die in Deutschland fertigen und unseren Anspruch ab Qualität teilen. Unsere Partner arbeiten wie wir nach ISO und DIN-Norm und verwenden auf Wunsch auch FSC zertifizierte Hölzer.</p>
    <br>
    <image-gallery :images="galleryImages"/>
    <br>
    <h4>Hinweis (gemäß Teledienstgesetz):</h4>
    <p>Für Websites Dritter, auf die der Herausgeber durch so genannte Links verweist, tragen die jeweiligen Anbieter die Verantwortung. Der Herausgeber ist für den Inhalt solcher Sites Dritter nicht verantwortlich. Weiter kann die Website des Herausgebers ohne dessen Wissen von anderen Websites mittels so genannter Links angelinkt werden. Der Herausgeber übernimmt keine Verantwortung für Darstellungen, Inhalt oder irgendeine Verbindung zur Parteigliederung des Herausgebers in Websites Dritter. Für fremde Inhalte ist der Herausgeber nur dann verantwortlich, wenn er von ihnen (d.h. auch von einem rechtswidrigen oder strafbaren Inhalt) positive Kenntnis hat und es dem Herausgeber technisch möglich und zumutbar ist, deren Nutzung zu verhindern. Der Herausgeber ist nach dem Teledienstgesetz jedoch nicht verpflichtet, die fremden Inhalte ständig zu überprüfen.</p>
    <br>
  </div>
</template>

<script>
export default {
  name: "Special",
  data() {
    return {
      galleryImages:this.importImages()
    };
  },
  methods:{
    importImages(){
      function importAll(r) { return r.keys().sort().map(r); }
      var images = importAll(require.context('@/assets/media/partners', false, /img\d+\.(png|jpe?g|svg)$/));
      return images.map(i=>{return {src:i}})
    }
  }
};
</script>

<style>
  #partner-box > .image-gallery{
    --max-image-width: 120px;
    --max-image-height: 120px;
  }
</style>
